import { axios as libAxios } from '@lovoldsystem/core.client'
import { userManager } from './user-manager'

export const axios = libAxios

let isRedirecting = false
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error?.status ?? error?.response?.status
    if (status === 401 && !isRedirecting) {
      isRedirecting = true
      userManager.signinRedirect()
    }
    return Promise.reject(error)
  },
)

export const fetchData = async <T>(
  url: string,
  params: Record<string, any>,
): Promise<T> => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) return

    if (Array.isArray(value)) {
      value.forEach(item => {
        if (item !== null && item !== undefined) {
          searchParams.append(key, String(item))
        }
      })
    } else {
      searchParams.append(key, String(value))
    }
  })

  const queryString = searchParams.toString()
  const response = await axios.get(`${url}?${queryString}`)

  return response.data as T
}